import Script from 'next/script';

interface AboutPageSchemaProps {
  imageUrl?: string;
  headline?: string;
  url?: string;
  publisherLogo?: string;
  publisherName?: string;
  schemaType?: 'AboutPage' | 'ContactPage';
}
export const AboutPageSchema = ({
  imageUrl,
  publisherName,
  publisherLogo,
  schemaType,
  ...rest
}: AboutPageSchemaProps) => {
  const type = schemaType || 'AboutPage';
  const imageParam = imageUrl
    ? {
        image: {
          '@type': 'ImageObject',
          url: imageUrl,
          width: 1920,
          height: 1080,
        },
      }
    : {};
  const schema = {
    '@context': 'https://schema.org/',
    '@type': type,
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': rest.url,
      name: rest?.headline,
    },
    ...imageParam,

    ...rest,
  };

  const publisher =
    publisherName && publisherLogo
      ? {
          publisher: {
            '@type': 'Organization',
            name: publisherName,
            logo: {
              '@type': 'ImageObject',
              url: publisherLogo,
              width: 60,
              height: 60,
            },
          },
        }
      : {};

  return (
    <Script id={`${type}-jsonld`} type='application/ld+json'>
      {JSON.stringify({ ...schema, ...publisher })}
    </Script>
  );
};

export default AboutPageSchema;
